/**
 * 移动端外壳约束容器。
 *
 * 响应式策略（推荐方案 B）：
 * - 手机（视口 < 600px，含 iPhone 16 Pro Max 440、国产机型 ≤412、@2x/@3x 高清屏按 DPR 缩放）：
 *   maxWidth 不触发 → width:100% 铺满真机，完全自适应。
 * - 桌面 / 平板（视口 ≥ 600px）：maxWidth:480 居中手机卡片，避免按钮被拉得过宽。
 *
 * 配合 index.html 的 viewport meta（width=device-width）使用，真机按真实宽度渲染不缩放。
 * 背景：设计稿 --app-bg 浅蓝竖向渐变。
 */
import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { T } from '@/theme/tokens';

export default function MobileFrame({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', sm: 480 },
        mx: 'auto',
        minHeight: '100vh',
        background: T.appBg,
        backgroundAttachment: 'fixed',
        color: T.ink,
        position: 'relative',
        boxShadow: { sm: '0 30px 70px rgba(16,24,40,.14), 0 2px 8px rgba(16,24,40,.06)' },
      }}
    >
      {children}
    </Box>
  );
}
